import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./styles/root.css";
import "./styles/animations.css";
import "./styles/essentials.css";
import "./styles/custom.css";
import "./styles/mobile.css";
import Main from "./Pages/Main";
import Template from "./Pages/Template";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/:pathName" element={<Template />} />
      </Routes>
    </Router>
  );
}

export default App;
